import { DeleteOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { useState } from "react";
import { generatePath, useNavigate, useParams } from "react-router";
import { RoutePaths } from "../routes";
import Button from "./Button";

interface Props {
  icon?: boolean;
  deleteWish?: () => Promise<void>;
}

export default function DeleteWishButton({ icon, deleteWish }: Props) {
  const { wishlistId } = useParams();

  const [isModelOpen, setIsModalOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const navigate = useNavigate();

  if (!wishlistId) {
    return <>Wishlist not found</>;
  }

  const onDelete = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    if (!deleteWish) {
      return;
    }
    setConfirmLoading(true);

    deleteWish();
    setIsModalOpen(false);
    setConfirmLoading(false);
    navigate(generatePath(RoutePaths.specificWishlist, { wishlistId }));
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setConfirmLoading(false);
  };

  return (
    <>
      <Button link onClick={onDelete} danger loading={!deleteWish}>
        <DeleteOutlined />
        {!icon && "Delete"}
      </Button>
      <Modal
        title="Removing the wish"
        open={isModelOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={confirmLoading}
      >
        <p>Are you sure?</p>
      </Modal>
    </>
  );
}
